/* ============================================================
   custom.js — Authentic Pace
   Junta "quantidade" + "Add to Cart" numa linha so e injeta os
   trust badges logo abaixo. Reversivel: some se este arquivo sair.
   ============================================================ */
(function () {
  var BADGES_HTML =
    '<span><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg>Secure Checkout</span>' +
    '<span><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="3" width="15" height="13"></rect><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"></polygon><circle cx="5.5" cy="18.5" r="2.5"></circle><circle cx="18.5" cy="18.5" r="2.5"></circle></svg>Free Tracked Shipping</span>' +
    '<span><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="1 4 1 10 7 10"></polyline><path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"></path></svg>30-Day Returns</span>';

  function arrangeQtyAtc() {
    var container = document.querySelector('.product__info-container');
    if (!container) return;

    var qty = container.querySelector('.product-form__quantity');
    var btnWrap = container.querySelector('.product-form__buttons');

    if (qty && btnWrap && !qty.closest('.qty-atc-row')) {
      var productForm = btnWrap.closest('product-form') || btnWrap.parentElement;

      var row = document.createElement('div');
      row.className = 'qty-atc-row';
      qty.parentNode.insertBefore(row, qty);
      row.appendChild(qty);
      row.appendChild(productForm);

      var badges = document.createElement('div');
      badges.className = 'atc-trust-badges';
      badges.innerHTML = BADGES_HTML;
      row.parentNode.insertBefore(badges, row.nextSibling);
    }

    // Libera a visibilidade (a classe abaixo so esconde durante o rearranjo)
    container.classList.remove('qty-atc-arranging');
  }

  function run() {
    var container = document.querySelector('.product__info-container');
    if (container) container.classList.add('qty-atc-arranging');
    arrangeQtyAtc();
  }

  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', run);

  // Re-roda no editor de tema e ao trocar de variante
  document.addEventListener('shopify:section:load', run);
})();